import { ADMIN_ROLES, ROLES } from './roles';

export const isSupervisorOnly = (currentUserRoles: string[] = []) => {
  const roles = Array.isArray(currentUserRoles) ? currentUserRoles : [];
  const isSupervisor = roles.includes(ROLES.SUPERVISOR);
  const isTechAdmin = roles.includes(ROLES.TECH_ADMIN);
  const isManagementAdmin = roles.includes(ROLES.MANAGEMENT_ADMIN);
  return isSupervisor && !isTechAdmin && !isManagementAdmin;
};

// Office Admin = MANAGEMENT_ADMIN without TECH_ADMIN.
// Has Supervisor-level access scoped to their Business Unit, but no resource creation.
export const isOfficeAdmin = (currentUserRoles: string[] = []) => {
  const roles = Array.isArray(currentUserRoles) ? currentUserRoles : [];
  return roles.includes(ROLES.MANAGEMENT_ADMIN) && !roles.includes(ROLES.TECH_ADMIN);
};

export const isBuScopedRole = (currentUserRoles: string[] = []) =>
  isSupervisorOnly(currentUserRoles) || isOfficeAdmin(currentUserRoles);

export const isAdminRole = (roleId?: string | null) => ADMIN_ROLES.includes(roleId as any);

export const isTargetUserAdmin = (selectedUser: { roles?: string[] } | null | undefined) => {
  if (!selectedUser || !Array.isArray(selectedUser.roles)) return false;
  return selectedUser.roles.some((roleId) => isAdminRole(roleId));
};
